export default Object.freeze({
  LANGUAGES_LIST: 'LANGUAGES_LIST',
  LANGUAGES_CLASSIFICATOR: 'LANGUAGES_CLASSIFICATOR',
  LANGUAGE_UPDATE_DATA: 'LANGUAGE_UPDATE_DATA',
  LANGUAGE_UPDATE: 'LANGUAGE_UPDATE',
  LANGUAGE_CREATE: 'LANGUAGE_CREATE',
  LANGUAGE_CREATE_DATA: 'LANGUAGE_CREATE_DATA',
  LANGUAGE_DELETE: 'LANGUAGE_DELETE',
});
